import React, {Component} from 'react'
import { connect } from 'react-redux'
import SideDirectory from 'components/landing/SideDirectory'
import LeaveMessage from 'components/landing/LeaveMessage'
import Hero from 'components/hero/Hero'
import Feature from 'components/landing/Feature'
import Pricing from 'components/landing/Pricing'
import Footer from 'components/footer/Footer'
import ApplyForm from 'components/careers/ApplyForm'
import {Helmet} from 'react-helmet'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import scrollIntoView from 'scroll-into-view'
import {
  isIE
} from "react-device-detect"

class Careers extends Component {

  render () {
    return (
      <div style={{position: 'relative'}}>
        <Helmet>
            <title>Careers &#8212; OwlGo</title>
        </Helmet>
      {/*  {!isIE ? <LeaveMessage /> : null}*/}
        <div className='hero--container' style={{paddingTop: '85.8px'}}>
          <div className='d-flex align-items-center hero--content-container' id='landing-page-hero'>
            <div className='container-fluid px-md-5 px-3'>
              <div className='row'>
                <div className='col-lg-6 d-sm-flex align-items-center justify-content-center'>
                  <div className='hero--col--text-container'>
                    <h1 className='mt-md-0 mt-3 mb-2 hero--col--h1'>OWLGO</h1>
                    <h2 className='mb-4 hero--col--h2'>Careers</h2>
                    <h3 className='mb-4 hero--col--h3'>Join our highly dynamic team now!</h3>
                    <div className='d-sm-flex flex-row justify-content-start'>
                      <HashLink exact to='/careers#join-now' scroll={el =>  scrollIntoView(el,{ time:700, align:{top:0, left: 0}})}>
                        <button className='btn btn-secondary d-flex align-items-center'>
                          <span className='pr-5'>Join now</span>
                          <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                        </button>
                      </HashLink>
                      {/*<HashLink exact to='/#features' className='mb-3' scroll={el =>  scrollIntoView(el,{ time:700, align:{top:0, left: 0}})}>
                        <button className='btn btn-secondary d-flex align-items-center'>
                          <span className='pr-5'>Learn More</span>
                          <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                        </button>
                      </HashLink>*/}
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 text-center'>
                  <img className='hero--col--image' alt='header' src='img/owlgo-3.png' />
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className='my-5 py-5'>
          <h2 className='mb-4 text-center'>Join Our Team Now!</h2>
          <div className='px-4' style={{maxWidth: '700px', margin: 'auto'}}>
            <p>OwlGo was created when like-minded event organisers faced the same problems and wanted a change.</p>
            <p>Join the team at the forefront of event innovation, and enjoy the benefits of working in a vibrant environment and competitive compensation in a flat organization with staff-centric initiatives!</p>
          </div>
        </div>
        <div className='my-5'>
          <div className='container py-5 my-5' style={{borderTop: '1px solid #979a94'}}>
            <h2 className='my-5 text-center'>Open Positions</h2>
            <div className='row'>
              <div className='col-md-3 text-center mb-4' style={{fontWeight: '700'}}>
                Web Developer Intern
              </div>
              <div className='col-md-9'>
                <div className='mb-3' style={{fontWeight: '700'}}>Responsibilities</div>
                <ul>
                  <li>To work with the development team on multiple projects with the end-user’s experience in mind.</li>
                  <li>To take pride and ownership in creating seamless and user-friendly experiences through our technological products.</li>
                  <li>To see through the development phase, including but not limited to envisioning, prototyping, programming, testing­­, debugging and maintaining the application software throughout the product lifecycle.</li>
                  <li>To developing solutions, optimising concepts and implementing best practice solutions within web UX, architecture and code quality.</li>
                </ul>
                <div className='mb-3' style={{fontWeight: '700'}}>Requirements</div>
                <ul className='mb-5'>
                  <li>Knowledge and experience in front-end programming, including JavaScript, React, CSS, and HTML</li>
                  <li>Understanding of good coding practices</li>
                  <li>Good time management skills and able to work in tight deadlines</li>
                  <li>Both independent and a strong team player</li>
                  <li>Proactive and have an intense willingness to learn and improve skills</li>
                  <li>Positive, resilient with a hustler and learner mentality</li>
                  <li>Good computing-related degree is preferred</li>
                  <li>Desire to work in an open and fast-paced startup culture/environment</li> 
                  <li>Willingness and ability to quickly learn and explore new technologies</li> 
                  <li>Experience or knowledge with building native Android and iOS apps would be a plus (optional)</li>
                </ul>
                <div className='d-flex justify-content-center'>
                <HashLink exact to='/careers#join-now' className='mb-3' scroll={el =>  scrollIntoView(el,{ time:700, align:{top:0, left: 0}})}>
                  <button className='btn btn-primary d-flex align-items-center'>
                    <span className='pr-5'>Join now</span>
                    <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                  </button>
                </HashLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='container py-5 my-5' style={{borderTop: '1px solid #979a94'}}>
          <span className="anchor" id="join-now"/>
          <h2 className='my-5 text-center'>Apply Here</h2>
          <ApplyForm />
        </div>
        <Footer />
      </div>
    )
  }

}

const mapStateToProps = ( state, props ) => ({
    routerHash: state.router.location.hash,
})

const mapDispatchToProps ={

    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Careers)



// WEBPACK FOOTER //
// ./src/croutes/careers/index.js